import { type } from '@/utils/type'

///////////////////////
//Actions types

//////////////////////////////////////////////////////////////////
// SEJOUR
/////////////////////////////////////////////////////////////////
export const ADM_SEJOUR_REQUEST =  type('ADM_SEJOUR_REQUEST')
export const ADM_SEJOUR_ENSURE =  type('ADM_SEJOUR_ENSURE')

export const ADM_SEJOUR_DETAIL_REQUEST =  type('ADM_SEJOUR_DETAIL_REQUEST')
export const ADM_SEJOUR_DETAIL_ENSURE =  type('ADM_SEJOUR_DETAIL_ENSURE')

export const ADM_SEJOUR_SAVE_REQUEST =  type('ADM_SEJOUR_SAVE_REQUEST')
export const ADM_SEJOUR_DELETE_REQUEST =  type('ADM_SEJOUR_DELETE_REQUEST')

export const ADM_SEJOUR_RESET_STATUS =  type('ADM_SEJOUR_RESET_STATUS')


//////////////////////////////////////////////////////////////////
// USER
/////////////////////////////////////////////////////////////////
export const ADM_USER_REQUEST =  type('ADM_USER_REQUEST')
export const ADM_USER_ENSURE =  type('ADM_USER_ENSURE')

export const ADM_USER_DETAIL_REQUEST =  type('ADM_USER_DETAIL_REQUEST')
export const ADM_USER_DETAIL_ENSURE =  type('ADM_USER_DETAIL_ENSURE')

export const ADM_USER_SAVE_REQUEST =  type('ADM_USER_SAVE_REQUEST')
export const ADM_USER_DELETE_REQUEST =  type('ADM_USER_DELETE_REQUEST')

export const ADM_USER_RESET_STATUS =  type('ADM_USER_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// COMMANDE
/////////////////////////////////////////////////////////////////
export const ADM_COMMANDE_REQUEST =  type('ADM_COMMANDE_REQUEST')
export const ADM_COMMANDE_ENSURE =  type('ADM_COMMANDE_ENSURE')

export const ADM_COMMANDE_DETAIL_REQUEST =  type('ADM_COMMANDE_DETAIL_REQUEST')
export const ADM_COMMANDE_DETAIL_ENSURE =  type('ADM_COMMANDE_DETAIL_ENSURE')

export const ADM_COMMANDE_SAVE_REQUEST =  type('ADM_COMMANDE_SAVE_REQUEST')
export const ADM_COMMANDE_DELETE_REQUEST =  type('ADM_COMMANDE_DELETE_REQUEST')

export const ADM_COMMANDE_RESET_STATUS =  type('ADM_COMMANDE_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// MAIL_TEMPLATE
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_TEMPLATE_REQUEST =  type('ADM_MAIL_TEMPLATE_REQUEST')
export const ADM_MAIL_TEMPLATE_ENSURE =  type('ADM_MAIL_TEMPLATE_ENSURE')

export const ADM_MAIL_TEMPLATE_DETAIL_REQUEST =  type('ADM_MAIL_TEMPLATE_DETAIL_REQUEST')
export const ADM_MAIL_TEMPLATE_DETAIL_ENSURE =  type('ADM_MAIL_TEMPLATE_DETAIL_ENSURE')

export const ADM_MAIL_TEMPLATE_SAVE_REQUEST =  type('ADM_MAIL_TEMPLATE_SAVE_REQUEST')
export const ADM_MAIL_TEMPLATE_DELETE_REQUEST =  type('ADM_MAIL_TEMPLATE_DELETE_REQUEST')

export const ADM_MAIL_TEMPLATE_RESET_STATUS =  type('ADM_MAIL_TEMPLATE_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// MAIL_SKIN
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_SKIN_REQUEST =  type('ADM_MAIL_SKIN_REQUEST')
export const ADM_MAIL_SKIN_ENSURE =  type('ADM_MAIL_SKIN_ENSURE')

export const ADM_MAIL_SKIN_DETAIL_REQUEST =  type('ADM_MAIL_SKIN_DETAIL_REQUEST')
export const ADM_MAIL_SKIN_DETAIL_ENSURE =  type('ADM_MAIL_SKIN_DETAIL_ENSURE')

export const ADM_MAIL_SKIN_SAVE_REQUEST =  type('ADM_MAIL_SKIN_SAVE_REQUEST')
export const ADM_MAIL_SKIN_DELETE_REQUEST =  type('ADM_MAIL_SKIN_DELETE_REQUEST')

export const ADM_MAIL_SKIN_RESET_STATUS =  type('ADM_MAIL_SKIN_RESET_STATUS')


//////////////////////////////////////////////////////////////////
// PAN_STATUS
/////////////////////////////////////////////////////////////////
export const ADM_PAN_STATUS_REQUEST =  type('ADM_PAN_STATUS_REQUEST')
export const ADM_PAN_STATUS_ENSURE =  type('ADM_PAN_STATUS_ENSURE')

export const ADM_PAN_STATUS_DETAIL_REQUEST =  type('ADM_PAN_STATUS_DETAIL_REQUEST')
export const ADM_PAN_STATUS_DETAIL_ENSURE =  type('ADM_PAN_STATUS_DETAIL_ENSURE')

export const ADM_PAN_STATUS_SAVE_REQUEST =  type('ADM_PAN_STATUS_SAVE_REQUEST')
export const ADM_PAN_STATUS_DELETE_REQUEST =  type('ADM_PAN_STATUS_DELETE_REQUEST')

export const ADM_PAN_STATUS_RESET_STATUS =  type('ADM_PAN_STATUS_RESET_STATUS')